import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCheckmarxComponent } from './simple-icons-checkmarx.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCheckmarxComponent ],
    exports:      [ SimpleIconsCheckmarxComponent ],
    bootstrap:    []
})
export class SimpleIconsCheckmarxModule {}
